import PropTypes from "prop-types";
import { Toolbar, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const RootStyle = styled(Toolbar)(({ theme }) => ({
    height: 96,
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(0, 1, 0, 3),
}));

const SelectionBar = ({ numSelected, children }) => {
    const { t } = useTranslation();
    return (
        <RootStyle
            sx={{
                ...(numSelected > 0 && {
                    color: "primary.main",
                    bgcolor: "primary.lighter",
                }),
            }}
        >
            <Typography component="div" variant="subtitle1">
                {t("SearchList.selected", { count: numSelected })}
            </Typography>
            {children}
        </RootStyle>
    );
};

SelectionBar.propTypes = {
    numSelected: PropTypes.number.isRequired,
    children: PropTypes.node,
};

export default SelectionBar;